import React, { useState, useCallback } from 'react';
import { motion } from 'framer-motion';
import { Lock, Delete } from 'lucide-react';
import { PASSCODE } from '../../data/roadmapData';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', 'del'];

export default function Digicode({ onUnlock }) {
  const [entry, setEntry] = useState('');
  const [error, setError] = useState(false);

  const press = useCallback(
    (key) => {
      if (key === 'del') {
        setError(false);
        setEntry((e) => e.slice(0, -1));
        return;
      }
      if (entry.length >= PASSCODE.length) return;
      setError(false);
      const next = entry + key;
      setEntry(next);
      if (next.length === PASSCODE.length) {
        if (next === PASSCODE) {
          setTimeout(() => onUnlock(), 180);
        } else {
          setTimeout(() => {
            setError(true);
            setEntry('');
          }, 220);
        }
      }
    },
    [entry, onUnlock]
  );

  return (
    <div className="rm-lock">
      <motion.div
        className="rm-lock-card"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
      >
        <div className="rm-lock-icon">
          <Lock size={26} strokeWidth={1.6} />
        </div>
        <h1 className="rm-lock-title">Espace protégé</h1>
        <p className="rm-lock-sub">Entre ton code pour accéder à ta roadmap.</p>

        <motion.div
          className="rm-dots"
          animate={error ? { x: [0, -10, 10, -8, 8, 0] } : { x: 0 }}
          transition={{ duration: 0.4 }}
        >
          {Array.from({ length: PASSCODE.length }).map((_, i) => (
            <span
              key={i}
              className={`rm-dot ${i < entry.length ? 'filled' : ''} ${
                error ? 'error' : ''
              }`}
            />
          ))}
        </motion.div>

        <div className="rm-lock-msg">
          {error ? 'Code incorrect, réessaie.' : ' '}
        </div>

        <div className="rm-keypad">
          {KEYS.map((k, i) =>
            k === '' ? (
              <span key={i} className="rm-key rm-key-empty" />
            ) : (
              <motion.button
                key={i}
                type="button"
                className={`rm-key ${k === 'del' ? 'rm-key-del' : ''}`}
                onClick={() => press(k)}
                whileTap={{ scale: 0.92 }}
                aria-label={k === 'del' ? 'Effacer' : k}
              >
                {k === 'del' ? <Delete size={22} strokeWidth={1.6} /> : k}
              </motion.button>
            )
          )}
        </div>
      </motion.div>
    </div>
  );
}
